import React from "react";

const TrainingBanner: React.FC = () => {
  return (
    <section
      className="relative min-h-[50vh] sm:h-[60vh] lg:h-[70vh] flex items-center justify-center text-white"
      style={{
        backgroundImage: `url(${"https://www.shegeeksout.com/wp-content/uploads/2023/02/business-workshop.jpg"})`,
        backgroundAttachment: "scroll", // Mobile compatibility ke liye scroll rakha hai
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay - Smudge/Shadow effect for better text readability */}
      <div className="absolute inset-0 bg-black/60 sm:bg-black/50"></div>

      {/* Banner Content */}
      <div className="relative z-10 text-center px-4 sm:px-6 max-w-4xl font-aligran">
        {/* Responsive Heading: text-3xl (Mobile) -> text-4xl (Tablet) -> text-5xl (Desktop) */}
        <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-extrabold mb-4 drop-shadow-2xl leading-tight sm:leading-tight">
          Empower Your Career with <br className="hidden sm:block" />
          <span className="text-orange-500">Professional IT Training</span>
        </h1>
        
        {/* Responsive Paragraph: Hidden on very small screens or text size reduced */}
        <p className="text-sm sm:text-lg mb-8 opacity-90 max-w-2xl mx-auto leading-relaxed">
          Learn industry-ready skills in Web Development, Java, React, and Full Stack —
          with expert mentors and real-world projects.
        </p>

        {/* Responsive Button */}
        <button className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-3.5 rounded-full font-bold text-sm sm:text-base transition-all duration-300 shadow-xl hover:shadow-orange-600/40 active:scale-95">
          Explore Courses
        </button>
      </div>

      {/* Optional: Responsive CSS for fixed background on Desktop only */}
      <style>{`
        @media (min-width: 1024px) {
          section { background-attachment: fixed !important; }
        }
      `}</style>
    </section>
  );
};

export default TrainingBanner;